import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.codigoTipoOS} value={props.elemento.codigoTipoOS}>{props.elemento.descrTipoOS}</option>
  )
};

const Lista = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrTipoOS" id="miLista" value={permiteUpdate?argsDocum.codigoTipoOS:idLista.codigoTipoOS} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

class VerCaOST2 extends React.Component {
  state={
    argsDocum: {descrCategOST: this.props.idLista.descrCategOST,
                observCategOST: this.props.idLista.observCategOST,
                codigoTipoOS: this.props.idLista.codigoTipoOS,
                descrTipoOS: this.props.idLista.descrTipoOS,
                _id: this.props.idLista._id},
    confirmaAct: false,
    open: false,
  }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      const argsDocum = this.state.argsDocum
      if(ev.target.name !== "descrCategOST"){
        if(ev.target.name === "descrTipoOS"){
          //No se permite modificar la categoría => se comentan las lineas siguientes
          // argsDocum['idTiUndMat'] = ev.target.value
          // var miLista = document.getElementById("miLista");
          // argsDocum['codigoTipoOS'] = miLista.options[miLista.selectedIndex].attributes[0].value
          // argsDocum['descrTipoOS'] = miLista.options[miLista.selectedIndex].text
        }else{
          argsDocum[ev.target.name] = ev.target.value 
        }
        this.setState({argsDocum});
      }
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {argsDocum, open, confirmaAct} = this.state;

    // console.log(this.props.idLista)
    // console.log(argsDocum)
    // console.log(this.props.list)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Tipo de recurso
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                <Form.Field>
                  <label style={this.props.styles.label}>Descripción</label>
                  <Form.Input autoComplete="off" name="descrCategOST" id="descrCategOST" value={argsDocum.descrCategOST} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrCategOST'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={this.props.styles.label}>Observaciones</label>
                  <Form.Input autoComplete="off" name="observCategOST" id="observCategOST" value={this.props.permiteUpdate?argsDocum.observCategOST:this.props.idLista.observCategOST} onChange={this.handleChange} placeholder='Observaciones' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'observCategOST'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Tipo de OS</label>
                    <Lista list={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default VerCaOST2
